import { FD_IMAGE_URL } from '../../../constants'
import { FTUXType } from '../../../types/fd-ftux.types'

export const bondsDebtMFsFTUX: FTUXType = [
  [
    {
      type: 'TEXT',
      text: `That’s great! You already <br />
invest in debt assets. But—`,
      className: 'text-[#D1ECFF] text-[20px] font-[400] leading-[150%] pb-3'
    },
    {
      type: 'TEXT',
      text: `Power FD could <br />
be all you need`,
      className: 'text-[36px] font-[500] leading-[130%] pb-3'
    },
    {
      type: 'TEXT',
      text: `or a smart addition.`,
      className: 'text-[#D1ECFF] text-[20px] font-[400] leading-[150%]'
    }
  ],
  [
    {
      type: 'TEXT',
      text: `Power FD gives you`,
      className: 'text-[#D1ECFF] text-[20px] font-[400] leading-[150%] pb-2'
    },
    {
      type: 'TEXT',
      text: `More Returns,
<br /> More Safety`,
      className: 'text-[32px] font-[500] leading-[130%] pb-9'
    },
    {
      type: 'IMAGE',
      imgSrc: `${FD_IMAGE_URL}/ftux/more-returns-table.svg`,
      maxWidth: '335px'
    }
  ],
  [
    {
      type: 'TEXT',
      text: `More Flexible,
<br /> Less Risky`,
      className: 'text-[32px] font-[500] leading-[130%] pb-9'
    },
    {
      type: 'IMAGE',
      imgSrc: `${FD_IMAGE_URL}/ftux/less-risky-table.svg`,
      maxWidth: '335px'
    }
  ],
  [
    {
      type: 'TEXT',
      text: `What makes
<br /> Power FD better?`,
      className: 'text-[32px] font-[500] leading-[120%] pb-8'
    },
    {
      type: 'CHEVRON_BOX',
      imgSrc: `${FD_IMAGE_URL}/ftux/shield-icon.svg`,
      title: 'It’s safe',
      text: 'Deposits insured up to ₹5L per bank by DICGC',
      className: 'pb-3 w-full px-5',
      isActionable: false
    },
    {
      type: 'CHEVRON_BOX',
      imgSrc: `${FD_IMAGE_URL}/ftux/flexible-icon.svg`,
      title: 'It’s flexible',
      text: 'Easily withdraw your investment anytime',
      className: 'pb-3 w-full px-5',
      isActionable: false
    },
    {
      type: 'CHEVRON_BOX',
      imgSrc: `${FD_IMAGE_URL}/ftux/grows-money-icon.svg`,
      title: 'It grows your money',
      text: 'Earn up to 8.15% returns',
      className: 'w-full px-5',
      isActionable: false
    }
  ]
]
